/*
 * @Author: zhulu
 * @Date: 2019-12-05 14:20:43
 * @Last Modified by: zhulu
 * @Description: {模块生效时间组件 effective-time}
 */
import React, { PureComponent } from 'react';
import moment from 'moment';
import { DatePicker } from 'antd';
import { language } from '../../../language';
import { cloneDeep, get, isEmpty } from 'lodash';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD HH:mm:ss';
export class EffectiveTime extends PureComponent<{
    onChange: (value: any) => void;
    value: {
        effectiveTime: { start: string; end: string; startGMT: string; endGMT: string };
    };
}> {
    change = (momentDates: Array<moment.Moment>, dataStrings: Array<string>) => {
        const { onChange, value } = this.props;
        let newValue = cloneDeep(value);
        let effectiveTime = newValue.effectiveTime;
        if (!effectiveTime) {
            effectiveTime = {
                start: '',
                end: '',
                startGMT: '',
                endGMT: '',
            };
        }
        effectiveTime.start = get(dataStrings, '[0]', '');
        effectiveTime.end = get(dataStrings, '[1]', '');
        // 取 GMT 时间
        if (!isEmpty(momentDates)) {
            effectiveTime.startGMT = momentDates[0].toString();
            effectiveTime.endGMT = momentDates[1].toString();
        } else {
            effectiveTime.startGMT = '';
            effectiveTime.endGMT = '';
        }
        newValue.effectiveTime = effectiveTime;
        onChange(newValue);
    };
    render() {
        const { value } = this.props;
        const effectiveTimeText = language.getText('components.Tools.effectiveTime');
        const { effectiveTime } = value;
        const start = get(effectiveTime, 'start', null);
        const end = get(effectiveTime, 'end', null);
        return (
            <div className="link-item-field">
                <label className="field-name">{effectiveTimeText}：</label>
                <RangePicker
                    style={{ width: '320px' }}
                    defaultValue={[
                        (start && moment(start, dateFormat)) || null,
                        (end && moment(end, dateFormat)) || null,
                    ]}
                    className="link-type"
                    showTime={{
                        defaultValue: [
                            moment('00:00:00', 'HH:mm:ss'),
                            moment('23:59:59', 'HH:mm:ss'),
                        ],
                    }}
                    format={dateFormat}
                    onChange={this.change}
                />
            </div>
        );
    }
}
